import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { utils } from "../helpers/utils";
import { mask } from "../components/mask";
import { search } from "./search";
import { responsive } from "../helpers/responsive";

/*------------------------------------*\
  #NAVIGATION
\*------------------------------------*/
class Navigation {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.IS_INIT = true;
    this.currentOpenedMenuId = null;
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT CLICK
    document.addEventListener('click', this.clickHandler);
    // DEFAULT EVENT KEYUP
    document.addEventListener('keyup', this.keyHandler);
    // RESPONSIVE HANDLER
    this.responsiveHandler();

    if(debug.DEBUG) console.log('modules/navigation.js');
  }
  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger="navigation--mobile"]')) {
      this.openMobileNav(event.target);
    } else if (event.target.matches('[data-js-trigger="navigation--toggle"]')) {
      this.openMenuNav(event.target);
    } else if (event.target.matches('[data-js-trigger="mask"]')){
      // TOGGLER CLICK SUR LE MASK
      this.closeAll();
    }
  }
  /**
   * CLOSE ON ESC KEY
   * 
   * Fermeture des sub-nav au clic sur la touche echap
   * @param {event} event 
   */
  keyHandler = (event) => {
    const key = event.key || event.keyCode;
    const target = event.target;
  
    if (utils.isEscapKey(key)) {
      this.closeAll();
      return;
    }
  
    if (utils.isTabKey(key)) {
      if (!target.closest('[data-js-module="navigation"]') && this.dataJsNavigationOpen) {
        this.closeAll();
        return;
      }
  
      const parent = this.getParentMenu(target);
      if (!parent) return;
  
      if (this.currentOpenedMenuId !== this.getMenuId(parent)) {
        if (this.isProductCategory(target) && responsive.is('lg')) return;
  
        this.getOpenedMenus(parent).forEach((element) => {
          this.toggleNav(element.id, false, false);
        });
      }
      return;
    }
  
    if (utils.isSpaceKey(key) && this.isProductCategory(target)) {
      const id = this.getControlsId(target);
      const targetElement = this.getTargetById(id);
      this.focusFirstElement(targetElement);
    }
  }
  /**
   * RESPONSIVE HANDLER
   */
  responsiveHandler = () => {
    document.addEventListener('RESPONSIVE_HAS_CHANGED', (event) => {
      this.navLevelsHandler();
      this.paramsControlersHander();
      this.mobileButtonLinksHandler();
      this.mobileButtonsLinksHandler();
      this.focusHandler();
      this.componentMaskHandler(false);
      // this.mobileNavElementHandler();
      this.IS_INIT = false;
    })
  };
  /**
   * NAV LEVELS HANDLER
   * 
   * gestionnaire des params de niveau de profondeur
   * et d'IDS des différents elements du menu
   */
  navLevelsHandler = () => {
    let level = 0;
    let menuId = 0;
    const elements = this.getAllControls();
    elements.forEach(element => {
      const id = this.getControlsId(element);
      const target = this.getTargetById(id);
      if (!target) return;

      const parent = this.getParentMenu(target);
      level = parent ? this.getLevel(parent) + 1 : 0;
      
      if (responsive.is('lg') && level > 1  && !element.classList.contains('c-navbar-item--product-category')) {
        if (id === 'distribution-protection-et-gestion-de-l-energie') {
          console.log(element);

        }
        element.removeAttribute('data-navigation-level');
        element.removeAttribute('aria-expanded');
        element.removeAttribute('data-js-trigger');
        target.removeAttribute('data-navigation-level');
        target.removeAttribute('data-navigation-menu-id');
      } else {
        element.setAttribute('data-navigation-level', level);
        element.setAttribute('aria-expanded', true);
        if (!element.matches('[data-js-trigger="navigation--mobile"]')){
          element.setAttribute('data-js-trigger', 'navigation--toggle');
        }
        target.setAttribute('data-navigation-level', level);
        target.setAttribute('data-navigation-menu-id', menuId);
        menuId++;
      }
    });
  }
  /**
   * PARAMS CONTROLERS HANDER 
   */
  paramsControlersHander = () => {
    const controlers = this.getAllControls();
    
    controlers.forEach((element) => {
      const shouldToggle = responsive.is('lg') && this.getLevel(element) === 0;
      this.toggleNav(this.getControlsId(element), shouldToggle, false, true);
    });
  }
  /**
   * FOCUS HANDLER
   * 
   * Gestionnaire des focus des liens
   */
  focusHandler = () => {
    this.DOM_MODULE[0].querySelectorAll('[data-navigation-level]').forEach(nav => {
      if (nav.getAttribute('aria-hidden') === 'true') {
        nav.setAttribute('inert', '');
      } else {
        nav.removeAttribute('inert');
      }
    });
  }
  /**
   * OPEN MOBILE NAV
   * @param {HTMLElement} element 
   */
  openMobileNav = (element) => {
    const state = !this.getTogglerState(element);
    this.toggleNav(this.getControlsId(element), state, true);
    if (!state) this.closeAll();
  }
  
  /**
   * OPEN MENU NAV
   * @param {HTMLElement} element 
   */
  openMenuNav = (element) => {
    const state = !this.getTogglerState(element);
    this.toggleNav(this.getControlsId(element), state, true);
  }
  /**
   * TOGGLE NAV
   * 
   * Gestionnaire d'état d'un menu
   * ouverture/fermeture
   * @param {string} id 
   * @param {boolean} state 
   * @param {boolean} focus 
   * @returns 
   */
  toggleNav = (id, state, focus, noMask) => {
    const buttons = this.DOM_MODULE[0].querySelectorAll(`[aria-controls="${id}"]`);
    const target = this.getTargetById(id);
    if (!target || !buttons.length) return;

    this.imagesGenerate(target, state);
  
    const menuId = this.getMenuId(target);
    const level = this.getLevel(target);
  
    // Handle auto-close
    if (state && responsive.is('lg') && this.currentOpenedMenuId && this.currentOpenedMenuId !== menuId) {
      const elementToClose = this.getElementByMenuId(this.currentOpenedMenuId);
      if (elementToClose) {
        const levelToClose = this.getLevel(elementToClose);
        if (level === levelToClose) {
          this.toggleNav(elementToClose.id, false, false);
        } else {
          const sameOpened = this.DOM_MODULE[0].querySelector(`[data-navigation-level="${level}"][aria-expanded="true"]`);
          if (sameOpened && this.getTogglerState(sameOpened)) {
            this.toggleNav(this.getControlsId(sameOpened), false, false);
          }
        }
      }
    }
  
    // Disable closing of product category menu
    if (this.isProductCategory(buttons[0]) && !state && focus && responsive.is('lg')) return;
  
    // Update buttons' attributes
    buttons.forEach((element) => {
      element.setAttribute('aria-expanded', state);
      if (element.matches('[data-navigation-item="back"], [data-navigation-item="see-all-category"]')) {
        element.removeAttribute('aria-current');
      } else if (state) {
        element.setAttribute('aria-current', true);
      } else if (!this.IS_INIT) {
        element.removeAttribute('aria-current');
      }
    });
  
    // Handle level-specific actions
    if ((level === 0 && !responsive.is('lg')) || level === 1 && responsive.is('lg')) {
      this.dataJsNavigationOpen = state;
      this.componentSearchHandler();
      if (noMask === undefined || noMask === false) {
        this.componentMaskHandler(this.dataJsNavigationOpen ? "header" : false);
      }
      if (state) {
        this.productsOpenFirst(target);
      }
    }
  
    this.currentOpenedMenuId = state ? menuId : null;
    target.setAttribute('aria-hidden', !state);
    this.focusHandler();
  
    // Handle focus
    if (focus && !responsive.is('lg') && !buttons[0].classList.contains('c-navbar-item--product-category')) {
      state ? this.focusFirstElement(target) : buttons[0].focus();
    }
  }

  imagesGenerate = (target, state) => {
    if (!target.querySelector('[data-js-img-src]') || !state || this.IS_INIT) return;
    const images = target.querySelectorAll('[data-js-img-src]');
    images.forEach((element) => {
      utils.imgGenerator(element);
    });
  }
  
  /**
   * MOBILE BUTTON LINKS HANDLER
   * 
   * Gestionnaire de création des button back
   */
  mobileButtonLinksHandler = () => {
    const elements = this.getAllControls();
    elements.forEach((element) => {
      if (!element.matches('[data-navigation-level="0"]')) {
        this.seeAllButtonHandler(element, !responsive.is('lg'));
        this.backButtonHandler(element, !responsive.is('lg'));
      }
    })
  }
  /**
   * MOBILE BUTTONS LINK SHANDLER
   * 
   * Gestionnaire de conversion des link en button et inversement
   */
  mobileButtonsLinksHandler = () => {
    const elements = this.getAllControls();
    elements.forEach((element) => {
      // if (element.matches('[data-navigation-item="product-category-theme"]')) {
      //   console.log(element);
      // }
      if (
        element.matches('[data-navigation-level="0"]') ||
        element.matches('[data-navigation-level="1"]') && !element.matches('[data-navigation-item="product-category-theme"]') ||
        element.classList.contains('c-navbar-item--product-category') && !element.matches('[data-navigation-item="product-category-theme"]') 
      ) {
        this.linkButtonConverter(element, 'button');
      } else if (element.matches('[data-navigation-item="see-all-category"]') || element.matches('[data-navigation-item="product-category-theme"]') || responsive.is('lg')) {
        this.linkButtonConverter(element, 'a');
      } else {
        this.linkButtonConverter(element, 'button');
      }
    });
  }
  
  /**
   * PRODUCTS OPEN FIRST
   * @param {HTMLElement} element 
   * @returns 
   */
  productsOpenFirst = (element) => {
    if (!responsive.is('lg')) return;
    const productElement = element.querySelector('.c-navbar-item--product-category[data-js-trigger="navigation--toggle"]');
    if (!productElement) return;
    const productElementId = this.getControlsId(productElement);
    this.toggleNav(productElementId, true, false);
  }
  /**
   * CLOSE NAV
   */
  closeNav = () => {
    this.dataJsNavigationOpen = false;
    this.closeOpenedNav();
  }
  /**
   * CLOSE ALL
   */
  closeAll = () => {
    this.dataJsNavigationOpen = false;
    this.componentSearchHandler();
    this.componentMaskHandler(false);
    this.closeOpenedNav();
  }
  /**
   * CLOSE OPENED NAV
   */
  closeOpenedNav = () => {
    const openedMenus = this.getOpenedMenus(this.DOM_MODULE[0]);
    openedMenus.forEach((element) => {
      const shouldClose = responsive.is('lg') && this.getLevel(element) === 0;
      this.toggleNav(element.id, shouldClose, false);
    });
  }
  /**
   * FOCUS FIRST ELEMENT
   * @param {HTMLElement} element 
   * @returns 
   */
  focusFirstElement = element => {
    const firstElement = element.querySelector('a, button');
    firstElement?.focus();
  };
  

  /**
   * LINK BUTTON CONVERTER
   * 
   * Conversion d'un link en button 
   * et inversement 
   * 
   * @param {HTMLElement} elementOld 
   * @param {string} type 
   */
  linkButtonConverter = (elementOld, type) => {
    const elementNew = document.createElement(type);
    const labelElement = elementOld.querySelector('.c-navbar-item__label');
    const label = labelElement ? labelElement.innerText : '';
  
    [...elementOld.children].forEach(child => {
      elementNew.appendChild(child.cloneNode(true));
    });
  
    if (!elementOld.children.length) {
      elementNew.innerText = elementOld.innerText;
    }
  
    [...elementOld.attributes].forEach(attribute => {
      if (type === 'button') {
        if (attribute.name === 'href') {
          elementNew.setAttribute('data-js-navigation-href', attribute.value);
        } else {
          elementNew.setAttribute(attribute.name, attribute.value);
        }
        elementNew.setAttribute('data-js-navigation-mobile-button', '');
  
        if (!elementNew.querySelector('.c-navbar-item__icon-after') &&
          (elementNew.classList.contains('c-navbar-item--secondary') || elementNew.classList.contains('c-navbar-item--main'))) {
          const iconNext = document.createElement('i');
          iconNext.classList.add('c-icon--chevron-right', 'u-hidden-from--lg', 'c-navbar-item__icon-after');
          iconNext.setAttribute('aria-hidden', true);
          elementNew.appendChild(iconNext);
        }
      } else {
        if (attribute.name === 'data-js-navigation-href') {
          elementNew.setAttribute('href', attribute.value);
        } else {
          elementNew.setAttribute(attribute.name, attribute.value);
        }
      }
  
      if (type === 'button' && label) {
        elementNew.setAttribute('title', `Ouvrir le menu : ${label}`);
      } else {
        elementNew.removeAttribute('aria-expanded');
        elementNew.setAttribute('title', `Accéder à la page : ${label}`);
      }
    });
  
    elementOld.replaceWith(elementNew);
  };
  
  /**
   * BACK BUTTON HANDLER
   * 
   * Création/suppression du button de retours
   * @param {HTMLElement} element 
   * @param {boolean} state 
   * @returns 
   */
  backButtonHandler = (element, state) => {
    const id = this.getControlsId(element);
    const target = this.getTargetById(id);
    if (!target || element.matches('[data-navigation-item="product-category-theme"]')) return;
  
    const backButton = target.querySelector('[data-navigation-item="back"]');
  
    if (state) {
      if (backButton) return;
  
      const clone = element.cloneNode(true);
      clone.setAttribute('data-navigation-item', 'back');
      clone.className = 'c-navbar-item c-navbar-item--back';
  
      const chevronRight = clone.querySelector('.c-icon--chevron-right');
      if (chevronRight) chevronRight.remove();
  
      const chevronBack = document.createElement('i');
      chevronBack.className = 'c-icon--chevron-left c-navbar-item__icon-before';
      chevronBack.setAttribute('aria-hidden', true);
      clone.prepend(chevronBack);
  
      const container = target.nodeName === 'UL' ? document.createElement('li') : clone;
      if (target.nodeName === 'UL') {
        container.className = 'm-navbar__item';
        container.prepend(clone);
      }
      target.prepend(container);
    } else {
      if (backButton) backButton.remove();
    }
  }
  

  /**
   * SEE ALL BUTTON HANDLER
   * 
   * Création/suppression du button de retours
   * @param {HTMLElement} element 
   * @param {boolean} state 
   * @returns 
   */
  seeAllButtonHandler = (element, state) => {
    const id = this.getControlsId(element);
    const target = this.getTargetById(id);
    if (!target || !element.href) return;
  
    const navLevel = parseInt(element.getAttribute('data-navigation-level'));
    const existingButton = target.querySelector('.c-navbar-item--see-all-category');
  
    if (state && navLevel > 1) {
      if (existingButton || element.matches('[data-navigation-item-js="false"]')) return;
  
      const clone = element.cloneNode(true);
      clone.setAttribute('data-navigation-item', 'see-all-category');
      clone.className = 'c-navbar-item c-navbar-item--see-all-category';
      clone.removeAttribute('aria-current');
  
      const chevronRight = clone.querySelector('.c-icon--chevron-right');
      if (chevronRight) chevronRight.remove();
  
      const spanNext = document.createElement('span');
      spanNext.className = 'c-navbar-item__see-all';
      spanNext.textContent = 'Voir tout';
  
      const chevronNext = document.createElement('i');
      chevronNext.className = 'c-icon--chevron-right';
      chevronNext.setAttribute('aria-hidden', true);
      spanNext.appendChild(chevronNext);
  
      clone.appendChild(spanNext);
  
      const container = target.nodeName === 'UL' ? document.createElement('li') : clone;
      if (target.nodeName === 'UL') {
        container.className = 'm-navbar__item';
        container.prepend(clone);
      }
      target.prepend(container);
    } else if (existingButton && responsive.is('lg')) {
      existingButton.remove();
    }
  }
  

  /**
   * COMPONENT SEARCH HANDLER
   */
  componentSearchHandler = () => {
    search.closeAll();
  }
  /**
   * COMPONENT MASK HANDLER
   */
  componentMaskHandler = (state) => {
    mask.display = state;
  }
  /**
   * IS PRODUCT CATEGORY
   * @param {HTMLElement} buttons 
   * @returns 
   */
  isProductCategory = (buttons) => {
    if (buttons.classList.contains('c-navbar-item--product-category')) return true;
  }
  /**********************************
   * GUETTER
   *********************************/
  getAllControls = () => {
    return this.DOM_MODULE[0].querySelectorAll('[data-js-trigger="navigation--mobile"], nav [aria-controls]')
  }
  getControlsId = (element) => {
    return element.getAttribute('aria-controls');
  }
  getMenuId = (element) => {
    return element.getAttribute('data-navigation-menu-id');
  }
  getLevel = (element) => {
    return parseInt(element.getAttribute('data-navigation-level'));
  }
  getParentMenu = (element) => {
    return element.parentNode.closest('[data-navigation-level]');
  }
  getOpenedMenus = (element) => {
    return element.querySelectorAll('[data-navigation-level][aria-hidden="false"]')
  }
  getTogglerState = (element) => {
    return utils.dataBool(element.getAttribute('aria-expanded'));
  }
  getTargetById = (id) => {
    return document.getElementById(id);
  }
  getElementByMenuId = (menuId) => {
    return this.DOM_MODULE[0].querySelector(`[data-navigation-menu-id="${menuId}"]`);
  }
  /**
   * STATE [data-js-navigation-open]
   * GETTER || SETTER
   * 
   * Etat d'ouverture des subnav
   * @param {bool} state
   */
  set dataJsNavigationOpen (state) {
    this.DOM_MODULE[0].setAttribute('data-js-navigation-open', state);
  }
  get dataJsNavigationOpen () {
    return utils.dataBool(this.DOM_MODULE[0].getAttribute('data-js-navigation-open'));
  }
}
export const navigation = new Navigation('[data-js-module="navigation"]'); 